const userAgent = navigator.userAgent;
const platform = {};
const platformNames = [];
const isWindowsPhone = (function() {
    const match = userAgent.match(/(Windows Phone)\s+(?:OS\s+)?((?:\d)(?:\.\d)?)?/i);

    if (match) {
        platform.winphoneVersion = match[2];
    }

    return Boolean(match);
})();

const pipeline = {
    firefox() {
        return /Firefox\/\d+\./.test(userAgent);
    },
    android: avoidWindowsPhoneMasking(() => {
        const match = userAgent.match(/Android\s([0-9.]*)/);

        const androidVersionString = match ? match[1] : false;
        if (androidVersionString) {
            platform.androidVersion = {
                number: parseFloat(androidVersionString),
                string: androidVersionString
            };
        }

        return Boolean(match);
    }),
    iOS: avoidWindowsPhoneMasking(() => {
        const result = /iPhone|iPad|iPod/g.test(userAgent);
        if (result) {
            const versionMatch = userAgent.match(/OS\s+(\d{1,2}).(\d)/);
            platform.iOSVersion = versionMatch ? versionMatch[1] + '.' + versionMatch[2] : 0;

            platform.isIPad = userAgent.includes('iPad');
            platform.isIPhone = userAgent.includes('iPhone');
            platform.isIPod = userAgent.includes('iPod');
            const windowScreen = window.screen;
            if (platform.isIPhone && (windowScreen.width === 320 && windowScreen.height === 480)) {
                platform.iPhoneVersion = '4';
            }

            const ratio = window.devicePixelRatio || 1;
            const screenWidth = windowScreen.width * ratio;
            const screenHeight = windowScreen.height * ratio;
            if (
                (platform.iPhoneXSeries =
                    (Math.min(screenHeight, screenWidth) === 1125 &&
                        Math.max(screenHeight, screenWidth) === 2436) || // X, XS
                    (Math.min(screenHeight, screenWidth) === 1242 &&
                        Math.max(screenHeight, screenWidth) === 2688) || // XS Max
                    (Math.min(screenHeight, screenWidth) === 828 &&
                        Math.max(screenHeight, screenWidth) === 1792)) // XR
            ) {
                /*  Нельзя повесить на body т.к. скрипт отрабатывает в head */
                document.documentElement.classList.add('__iphonex');
            }
        }

        return result;
    }),
    ie() {
        return userAgent.includes('Trident');
    },
    // Edge: function() {
    //    return userAgent.indexOf('Edge') !== -1;
    // },
    winphone() {
        return isWindowsPhone;
    },
    chrome() {
        return userAgent.includes('Chrome');
    },
    operamini() {
        return window.operamini;
    },
    yandexBrowser() {
        return userAgent.includes('YaBrowser');
    },
    okApp() {
        return /OK(iOS|Android).*(\bO[k|K]App\b)/.test(userAgent);
    },

    /* Depends on pipline order, so should be last */
    desktop() {
        return (
            !platform.android &&
            !platform.iOS &&
            !userAgent.includes('ws Phone') &&
            !userAgent.includes('Mobile')
        );
    }
};

function avoidWindowsPhoneMasking(actualCheckCallback) {
    return function() {
        if (isWindowsPhone) {
            // Windows Phone masks itself as all kinds of things. As a result, we must ignore its flags to avoid issues with platform version checking.
            // This works against a user agent of the following kind:
            // "Mozilla/5.0 (Mobile; Windows Phone 8.1; Android 4.0; ARM; Trident/7.0; Touch; rv:11.0; IEMobile/11.0; NOKIA; Lumia 520) like iPhone OS 7_0_3 Mac OS X AppleWebKit/537 (KHTML, like Gecko) Mobile Safari/537"
            return false;
        }

        return actualCheckCallback();
    };
}

for (const key in pipeline) {
    /* eslint "no-prototype-builtins": "off" */
    if (pipeline.hasOwnProperty(key)) {
        const testResult = pipeline[key]();
        platform[key] = testResult;
        if (testResult) {
            platformNames.push(key);
        }
    }
}

platform.name = platformNames.join(',') || 'unknown';

export default platform;